// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MjOfV","header":"Home_header__LYx1J","logo":"Home_logo__yjKrE","link":"Home_link__V6Qxt","input":"Home_input__HVCOd","icon":"Home_icon__7htCh"};